import React from 'react';
import {
  Box,
  Container
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Page from 'src/components/Page';
import TopicsGrid from './TopicsGrid';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const TopicsView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Topics"
    >
      <Container maxWidth="lg">
        <Box mt={3}>
          <TopicsGrid />
        </Box>
      </Container>
    </Page>
  );
};

export default TopicsView;
